<script lang="ts">
	export let question: string;
	export let answer: string;
	export let open: boolean = false;
	export let category: string | false = false;
</script>

<div class="question flex flex-col justify-around gap-14 border-b-2 py-10 last:border-b-0">
	<div
		class="relative flex cursor-pointer items-center justify-between"
		on:click={() => (open = !open)}
		on:keypress={() => (open = !open)}
	>
		<div>
			{#if category}
				<div class="mb-6 text-xs tracking-0.14 text-primary lg:text-lg">{category}</div>
			{/if}
			<h4 class="text-xl font-bold text-dark lg:text-3xl lg:font-normal">
				{question}
			</h4>
		</div>
		<div
			class="expand__button {!open
				? 'closed'
				: ''} w-10 before:w-5 before:bg-dark after:w-5 after:bg-dark lg:before:w-10 lg:after:w-10"
		/>
	</div>
	<p class:hidden={!open} class="text-lg text-dark lg:text-xl" />
	<p class:hidden={!open} class="text-lg text-dark lg:text-xl">
		{@html answer}
	</p>
</div>

<style>
	.expand__button {
		display: flex;
		outline: none;
		height: 20px;
		width: 40px;
		border: 0px;
		padding: 0px;
		background: transparent;
		transition: all 250ms ease-out;
	}

	.expand__button:before,
	.expand__button:after {
		content: '';
		height: 2px;
		position: absolute;
		top: 50%;
		right: 0;
		transition: all 250ms ease-out;
		will-change: transform;
		border-radius: 50px;
	}

	.closed.expand__button:after {
		transform: translateY(0) rotate(90deg);
	}
</style>
